import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";

export const Wrapper = styled.div<{ reachOutMobile?: number }>`
    display: block;
    position: fixed;
    bottom: ${({ reachOutMobile }) => (reachOutMobile ? `${reachOutMobile}px` : 0)};
    left: 0;
    right: 0;
    justify-content: space-between;
    width: 100%;
    padding-top: ${theme.space[2]}px;
    background: ${theme.colors.primaryWhite};
    box-shadow: 0px -2px 15px rgba(0, 0, 0, 0.15);
    z-index: ${theme.zIndex.gradesNav + 1};

    @media ${getBreakpoint("up", "lg")} {
        display: none;
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space[2]}px;
    padding: 0 ${theme.space[2]}px ${theme.space[2]}px ${theme.space[2]}px;
`;

export const Clamp = styled.span`
    display: block;
    min-width: 75px;
    @media ${getBreakpoint("down", "lg")} {
        width: 75px;
        min-width: auto;
        max-height: 40px;
        line-height: 1.5rem;
        overflow: hidden;
        /* stylelint-disable */
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        /* stylelint-enable */
    }
`;

export const NextButton = styled(Button.Primary)<{ showPrice?: boolean; showFullWidth?: boolean }>`
    display: flex;
    position: relative;
    flex-shrink: 0;
    align-items: center;
    max-width: 120px;
    min-height: 46px;
    margin-left: 15px;
    padding: 5px 20px 9px;
    font-size: 1.5rem;
    white-space: normal;

    &,
    &:focus {
        background-color: ${theme.colors.primaryBlack};
    }

    .bz & {
        &,
        &:focus {
            background-color: ${theme.colors.bz4x};
        }
    }

    ${({ showPrice, showFullWidth }) =>
        (!showPrice || showFullWidth) &&
        css`
            justify-content: center;
            width: 100%;
            max-width: none;
            margin-left: 0;
        `};

    @media ${getBreakpoint("down", "sm")} {
        flex-grow: 1;
        max-width: none;
        margin-left: 0;
        ${Clamp} {
            width: 100%;
        }
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: 15px;
        ${({ showPrice, showFullWidth }) =>
            (!showPrice || showFullWidth) &&
            css`
                margin-left: 15px;
                margin-right: 0;
            `};
        @media ${getBreakpoint("down", "sm")} {
            margin-left: 15px;
            margin-right: 0;
        }
    }
`;

export const PaymentSwitch = styled.button`
    display: block;
    width: 100%;
    padding: 12px ${theme.space[2]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.3rem;
    line-height: 2rem;
    text-align: start;
    color: ${theme.colors.grey4};
    background-color: ${theme.colors.grey1};
    border: 0;
    border-radius: 0;

    @media ${getBreakpoint("up", "lg")} {
        display: none;
    }
`;

export const PaymentControls = styled.div`
    display: flex;
    background-color: ${theme.colors.grey4};

    ${PaymentSwitch} {
        display: flex;
        column-gap: ${theme.space[1]}px;
        align-items: center;
        justify-content: center;
        padding: ${theme.space[3] / 2}px ${theme.space[2]}px;
        font-family: ${theme.fonts.regular};
        font-size: 1.3rem;
        line-height: 1.8rem;
        color: ${theme.colors.primaryBlack};

        &:first-child:not(:last-child) {
            border-right: 1px solid ${theme.colors.grey2};
        }
    }
    @media ${getBreakpoint("up", "lg")} {
        display: none;
    }
`;
